import {
  BlockingStep,
  FlowVersion,
  getBlockingSteps,
} from '@activepieces/shared';

import { policyHooks } from '@/features/policy/lib/policy-hooks';

type FlowActivationBlock = {
  isBlocked: boolean;
  blockingSteps: BlockingStep[];
};

export const useFlowBlockingPieces = (
  flowVersion: FlowVersion,
): FlowActivationBlock => {
  const { data: policy } = policyHooks.usePolicy();
  if (!policy) {
    return { isBlocked: false, blockingSteps: [] };
  }
  const blockingSteps = getBlockingSteps(
    flowVersion,
    policy.advancedPiecesEnabled,
  );
  return { isBlocked: blockingSteps.length > 0, blockingSteps };
};
